import { DateTime } from 'luxon'

export const isCoachOwnGroupEvent = ({ user, groupEvent }) => {
  if (!user || !groupEvent) return false

  const coachExternalId = groupEvent?.coach?.externalId
  const coachId = groupEvent?.coach?.id

  if (
    user?.externalId &&
    coachExternalId &&
    user.externalId === coachExternalId
  ) {
    return true
  }

  if (user?.id && coachId && user.id === coachId) {
    return true
  }

  return false
}

export const getRegistrationClosedEffective = ({
  user,
  groupEvent,
  inviteValid = false,
}) => {
  if (inviteValid) return false

  const registrationClosed = Boolean(groupEvent?.registrationClosed)
  const isCoachOwn = isCoachOwnGroupEvent({ user, groupEvent })

  // Coaches should be able to register for their own events even if the public
  // registration window is closed.
  const shouldOverride = registrationClosed && isCoachOwn
  return shouldOverride ? false : registrationClosed
}

export const getRegistrationDisabled = ({
  user,
  groupEvent,
  inviteValid = false,
}) => {
  const registrationClosedEffective = getRegistrationClosedEffective({
    user,
    groupEvent,
    inviteValid,
  })

  return (
    Boolean(groupEvent?.isCanceled) ||
    registrationClosedEffective ||
    (!inviteValid && Boolean(groupEvent?.registrationFull))
  )
}

export const isRegistrationNotYetOpen = groupEvent => {
  const openAt = groupEvent?.registrationOpenDateTime
  if (!openAt) return false
  const openDateTime = DateTime.fromISO(openAt)
  return openDateTime.isValid && openDateTime > DateTime.now()
}

export const getRegistrationButtonLabel = ({
  user,
  groupEvent,
  paymentRequired,
  paymentLabel = 'Confirm and Pay',
  registerLabel = 'Register',
  inviteValid = false,
}) => {
  if (groupEvent?.isCanceled) return 'Event Canceled'
  const registrationClosedEffective = getRegistrationClosedEffective({
    user,
    groupEvent,
    inviteValid,
  })
  if (registrationClosedEffective) {
    if (isRegistrationNotYetOpen(groupEvent)) {
      const openDateTime = DateTime.fromISO(
        groupEvent.registrationOpenDateTime,
        { zone: 'utc' },
      ).setZone(groupEvent.timezone || 'local')
      return `Registration Opens ${openDateTime.toFormat('LLL d, h:mm a')}`
    }
    return 'Registration Closed'
  }
  if (groupEvent?.registrationFull && !inviteValid) return 'Registration Full'
  if (paymentRequired) return paymentLabel
  return registerLabel
}
